import Close from 'assets/icons/Close';
import Footer from 'components/Basket/Footer';
import Heading from 'components/text/Heading';
import ProductCardMiniBasket from 'components/products/productCardMini/Basket';
import PropTypes from 'prop-types';
import React from 'react';
import { injectModel } from 'state';
import styled from 'libs/styled';
import { useSelector } from 'react-redux';

const Header = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
`;

const Products = styled('div')`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow: auto;
    padding-bottom: 38px;

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    ::-webkit-scrollbar {
        display: none;
    }
`;

const Basket = ({ products, closeBasket }) => {
    const label = useSelector(state => state.header.data.basket.label);

    return (
        <>
            <Header>
                <Heading fontSize={['2.4rem', null, '3.2rem']} size="md">
                    {label}
                </Heading>
                <button type="button" onClick={() => closeBasket()}>
                    <Close />
                </button>
            </Header>
            <Products>
                {products.map((product, index) => (
                    <ProductCardMiniBasket
                        key={product.id}
                        position={index}
                        onClickPermalink={() => closeBasket()}
                        {...product}
                    />
                ))}
            </Products>
            <Footer closeBasket={closeBasket} />
        </>
    );
};

Basket.propTypes = {
    closeBasket: PropTypes.func.isRequired,
    products: PropTypes.object,
};

export default injectModel('basket')(Basket);
